import { withInstall } from '../../utils/install';

import AutoComplete from './index.vue';

export const IvueAutoComplete = withInstall(AutoComplete);
export default IvueAutoComplete;

export * from './index.vue';
